import {registerPlugin} from '@capacitor/core';

/**
 * Native-only token vault shared by the Capacitor WebView and Flutter.
 * Values never appear in a route, URL, analytics event or Flutter arguments.
 */
export interface NativeSecureSessionPlugin {
  read(): Promise<NativeSecureSessionValues>;
  write(options: NativeSecureSessionWriteOptions): Promise<void>;
  remove(options: {keys: NativeSecureSessionKey[]}): Promise<void>;
  clear(): Promise<void>;
}

export type NativeSecureSessionKey = 'token' | 'refreshToken' | 'tokenExpiration' | 'remember';

export interface NativeSecureSessionValues {
  token?: string;
  refreshToken?: string;
  tokenExpiration?: string;
  remember?: string;
}

export interface NativeSecureSessionWriteOptions extends NativeSecureSessionValues {
}

export const NativeSecureSession = registerPlugin<NativeSecureSessionPlugin>('NativeSecureSession');
